import { Flex, styled } from '@grupoboticario/flora-react';

export const Progress = {
  Component: styled(Flex, {
    gap: '$2',
    width: '100%',
  }),

  Circle: styled('svg', {
    height: '100%',
    width: '100%',

    circle: {
      fill: 'transparent',
      stroke: '$nonInteractiveAltAuxiliar',
      strokeWidth: '$1',
      transform: 'rotate(-90deg)',
      transformOrigin: '50% 50%',
    },

    text: {
      fontSize: '$bodySmall',
      fill: '$nonInteractivePredominant',
    },

    /* SIZES */
    "&[data-size='medium']": {
      circle: {
        strokeWidth: '$2',
      },
    },

    "&[data-size='large']": {
      circle: {
        strokeWidth: '$3',
      },
    },

    /* REVERSE */
    "&[dataReverse='true']": {
      circle: {
        transform: 'rotate(-90deg) scaleY(-1)',
      },
    },

    /* COLOR */
    "&[data-color='primary']": {
      circle: {
        '&:nth-of-type(2)': {
          stroke: '$backgroundAltPrimary',
        },
      },
    },

    "&[data-color='secondary']": {
      circle: {
        '&:nth-of-type(2)': {
          stroke: '$backgroundTertiary',
        },
      },
    },

    "&[data-color='tertiary']": {
      circle: {
        '&:nth-of-type(2)': {
          stroke: '$backgroundAltTertiary',
        },
      },
    },

    "&[data-color='success']": {
      circle: {
        '&:nth-of-type(2)': {
          stroke: '$success-standard',
        },
      },
    },

    "&[data-color='error']": {
      circle: {
        '&:nth-of-type(2)': {
          stroke: '$error-standard',
        },
      },
    },

    "&[data-color='alert']": {
      circle: {
        '&:nth-of-type(2)': {
          stroke: '$alert-standard',
        },
      },
    },
  }),

  Info: styled('div', {
    color: '$darkLight',
    display: 'block',
    textAlign: 'center',
    width: '100%',
  }),

  Range: styled('progress', {
    appearance: 'none',
    height: '$1',
    isolation: 'isolate',
    width: '100%',
    position: 'relative',

    '&[value]::-webkit-progress-bar': {
      background: '$nonInteractiveAltAuxiliar',
      borderRadius: '$large',
    },

    '&[value]::-webkit-progress-value': {
      background: '$backgroundAltPrimary',
      borderRadius: '$large',
    },

    '&::after': {
      color: '$nonInteractiveAltPredominant',
      left: '50%',
      margin: '$0',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },

    "&[data-color='standard']": {
      '&[value]::-webkit-progress-value': {
        background: '$actionableDefault',
      },
    },

    "&[data-color='primary']": {
      '&[value]::-webkit-progress-value': {
        background: 'backgroundAltPrimary',
      },
    },

    "&[data-color='secondary']": {
      '&[value]::-webkit-progress-value': {
        background: 'backgroundTertiary',
      },
    },

    "[data-color='tertiary']": {
      '&[value]::-webkit-progress-value': {
        background: 'backgroundAltTertiary',
      },
    },

    "&[data-color='success']": {
      '&[value]::-webkit-progress-value': {
        background: '$success-standard',
      },
    },

    "&[data-color='error']": {
      '&[value]::-webkit-progress-value': {
        background: '$error-standard',
      },
    },

    "&[data-color='alert']": {
      '&[value]::-webkit-progress-value': {
        background: '$alert-standard',
      },
    },

    "&[data-size='medium']": {
      borderRadius: '$large',
      height: '$3',

      '&[value]::-webkit-progress-bar, &[value]::-webkit-progress-value': {
        borderRadius: '$large',
      },

      "&[data-showlabel='true']": {
        '&::after': {
          content: 'attr(data-label)',
          fontSize: 'auxiliar',
        },
      },
    },

    "&[data-size='large']": {
      borderRadius: '$large',
      height: '$6',

      '&[value]::-webkit-progress-bar, &[value]::-webkit-progress-value': {
        borderRadius: '$large',
      },

      "&[data-showlabel='true']": {
        '&::after': {
          content: 'attr(data-label)',
        },
      },
    },
  }),
};
